__turbopack_context__.v({
  "description": "ArticleTerms-module-scss-module__PEYtTW__description",
  "promotionTerms": "ArticleTerms-module-scss-module__PEYtTW__promotionTerms",
});
